import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment-timezone';

import { ProductionContractReport, Regulation, User } from 'src/app/core/models';
import {
  ContractService, ProductionReportService, RegulationService,
  SessionService, PreProcessSettingsService, UserService, UserGroupService,
  StorageKey, StorageService, ContractGlobalService, RegionService
} from 'src/app/core/services';

@Component({
  selector: 'app-production-report',
  templateUrl: './production.component.html'
})
export class ProductionReportComponent implements OnInit {
  public contracts: any[] = [];
  public regulations: Regulation[] = [];
  public regulationsIds: any[] = [];
  public users: User[] = [];
  public userGroups: any[] = [];
  public contractProduction: ProductionContractReport[] = [];
  public contractsUser: any[] = [];
  public dataProduction: any = [];
  public stepsIds: any[] = ['triage', 'typing', 'verifyValid', 'verifyInvalid', 'validate'];
  public stepsSession: any = ['triage', 'typing', 'verify', 'validate'];
  public stepsTranslated;

  constructor(
    private contractsGlobalService: ContractGlobalService,
    private productionReportService: ProductionReportService,
    private contractService: ContractService,
    private sessionService: SessionService,
    private regulationService: RegulationService,
    private preProcessSettingsService: PreProcessSettingsService,
    private userService: UserService,
    private userGroupService: UserGroupService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private regionService: RegionService,
  ) {
    if (this.contractsGlobalService.contracts != null) {
      if (this.contractsGlobalService.contracts.length === 1) {
        const contract = this.contractsGlobalService.contracts.shift();
        this.router.navigate([contract], { relativeTo: this.route }).then(() => {
          window.location.reload();
        });
      }
    }
  }

  async ngOnInit() {
    const currentUser = this.storageService.get(StorageKey.currentUser);
    const contractId = this.router.url.split('/').pop();
    await this.regionService.list({ name: 'Brasil' }).then(async res => {
      const region = res.result[0];
      await this.regulationService.list({ regionId: region.id }).then(r => {
        this.regulations = r.result;
        this.regulationsIds = this.regulations.map(regulation => regulation.id);
      });
      const paramsContract: any = {};
      if (!isNaN(Number(contractId))) {
        paramsContract.id = contractId;
      }
      await this.userService.getAll({ 'verified[eq]': 'true' })
        .then(users => this.users = users);

      await this.userGroupService.getAll().then(userGroups => {
        this.userGroups = userGroups;

        userGroups.map(group => {
          if (currentUser.groupIds.includes(group.id) && group.permissions.includes('PreProcessProductionReport')) {
            this.contractsUser.push(group.contractId);
          }
        });
      });
      if (!currentUser.superUser && isNaN(Number(contractId))) {
        paramsContract['id[in]'] = `[${this.contractsUser.join()}]`;
      }
      await this.contractService.list(paramsContract)
        .then(resContract => {
          const contracts = resContract.result;
          this.contracts = contracts.filter(c =>
            c.modules.find(m => m === 'preProcess')).map(contract => {
              const stepsContract = this.stepsIds;
              const contractGroup = this.userGroups
                .filter(group => group.contractId === contract.id)
                .map(group => ({ id: group.id, name: group.prettyId, users: group.userIds }));

              return {
                id: contract.id, contractName: contract.name,
                steps: stepsContract, groups: contractGroup,
                timezone: contract.timezone
              };
            });
          const contractsIds = contracts.map(c => c.id);
          const now = new Date().toISOString();
          const today = now.split('T')[0];
          const sessionsParams: any = {};
          sessionsParams['contractId[in]'] = `[${contractsIds.join()}]`;
          sessionsParams['startsAt[gte]'] = moment(now).utc().subtract(7, 'days').format();
          sessionsParams['startsAt[lte]'] = moment(now).utc().format();
          sessionsParams['step[in]'] = `[${this.stepsIds.join()}]`;
          sessionsParams.limit = 10000;

          this.sessionService.getAll(sessionsParams).then(async (sessions) => {
            for (const contract of this.contracts) {
              const objContract: any = {};
              const sessionContract = sessions.filter(item => Number(item.contractId) === contract.id);
              objContract.id = contract.id;
              objContract.name = contract.contractName;
              await this.preProcessSettingsService.getById(contract.id).then((preProcess) => {
                let violationSteps = [];
                if (preProcess.violationSteps !== undefined) {
                  violationSteps = Object.keys(preProcess.violationSteps)?.filter(s => !['firstStep', 'lotAttribution'].includes(s));
                }
                objContract.steps = violationSteps;
                objContract.collapse = false;
                objContract.totalWork = 0;
                objContract.timeWorked = 0;
                objContract.regulations = [];
                objContract.groups = contract.groups;
                objContract.timezone = contract.timezone;

                objContract.users = [];
                let usersWithSessions = sessionContract.map(item => item.userId).
                  filter((value, index, self) => self.indexOf(value) === index);
                let usersContract;

                if (contract.groups) {
                  usersContract = contract.groups
                    .map(group => group.users)
                    .flat()
                    .reduce((list, userId) => {
                      if (!list.includes(userId)) { list.push(userId); }
                      return list;
                    }, []);

                  usersWithSessions = usersContract.concat(usersWithSessions).reduce((list, userId) => {
                    if (!list.includes(userId)) { list.push(userId); }
                    return list;
                  }, []);
                }
                const countToday = {};
                for (const user of usersWithSessions) {
                  const objUser: any = {};
                  const userSessions = sessionContract.filter(item => item.userId === user);
                  objUser.id = user;

                  const userInfo = this.users.find(item => item.id === user);
                  objUser.name = (userInfo && userInfo.name) || user;
                  objUser.collapse = false;
                  objUser.timeWorked = 0;
                  objUser.totalWork = 0;
                  objUser.superUser = (userInfo && userInfo.superUser) || false;
                  objUser.noInfo = userInfo === undefined ? true : false;
                  objUser.noGroup = !usersContract.includes(user);

                  contract.steps.map(step => {
                    const stepValid = step;
                    const sessionFromStep = userSessions.filter(item => item.step === stepValid);
                    objUser[step] = this.getSessionsSize(sessionFromStep, step);
                  });

                  objUser.dates = [];

                  const datesWithSessions = userSessions.reduce((dates, session) => {
                    const startsAt = moment.tz(session.startsAt, contract.timezone).format();
                    const date = startsAt.split('T')[0];
                    if (!dates.includes(date)) { dates.push(date); }
                    return dates.sort().reverse();
                  }, []);
                  const countTodayByStep = {};
                  for (const date of datesWithSessions) {
                    const objDate: any = {};
                    const dateSessions = userSessions.filter(session => {
                      const startsAt = moment.tz(session.startsAt, contract.timezone).format();
                      return startsAt.split('T')[0] === date;
                    });
                    objDate.date = date;
                    objDate.timeWorked = 0;
                    objDate.totalWork = 0;
                    objDate.collapse = false;
                    const dataSessionsOrder: any = dateSessions.sort((a, b): any => Number(a.startsAt) - Number(b.startsAt));
                    const sessionsDates = [{
                      startsAt: dataSessionsOrder[0].startsAt,
                      modifiedAt: dataSessionsOrder[dataSessionsOrder.length - 1].modifiedAt,
                    }];
                    objDate.timeWorked = sessionsDates.reduce(this.getTimeWorked, 0);

                    contract.steps.map(step => {
                      const stepValid = step;
                      const sessionFromStep = dateSessions.filter(item => item.step === stepValid);
                      objDate[step] = this.getSessionsSize(sessionFromStep, step);
                      if (date === today) {
                        countTodayByStep[step] = this.getSessionsSize(sessionFromStep, step);
                      }
                    });

                    objDate.regulations = [];
                    for (const regulation of this.regulations) {
                      const objRegulation: any = {};
                      const regulationsSessions = dateSessions.filter(session => session[regulation.id] ||
                        session['invalid#' + regulation.id] || session['valid#' + regulation.id]);

                      objRegulation.code = regulation.code;
                      objRegulation.id = regulation.id;
                      objRegulation.totalWork = 0;

                      contract.steps.map(step => {
                        const stepValid = step;
                        const sessionFromStep = regulationsSessions.filter(item => item.step === stepValid);
                        objRegulation[step] = this.getSessionsSize(sessionFromStep, step, regulation.id);
                        objDate.totalWork += objRegulation[step];
                        objRegulation.totalWork += objRegulation[step];
                      });

                      if (regulationsSessions.length > 0 && !objContract.regulations.find(item => item.id === regulation.id)) {
                        const regulationData = {
                          id: regulation.id,
                          code: regulation.code,
                          description: regulation.description,
                          prettyName: regulation.prettyName
                        };
                        objContract.regulations.push(regulationData);
                      }

                      if (objRegulation.totalWork > 0) {
                        objDate.regulations.push(objRegulation);
                      }
                    }

                    if (objDate.totalWork > 0) {
                      objUser.totalWork += objDate.totalWork;
                      objUser.timeWorked += objDate.timeWorked;
                      objDate.regulations.sort((a, b) => (a.totalWork > b.totalWork) ? -1 : 1);
                      objUser.dates.push(objDate);
                    }
                  }
                  if (objUser.superUser === false && objUser.totalWork > 0) {
                    objContract.totalWork += objUser.totalWork;
                    objContract.timeWorked += objUser.timeWorked;
                    objContract.users.push(objUser);
                  }
                  contract.steps.map(step => {
                    countToday[step] = countToday[step] || 0;
                    countToday[step] += countTodayByStep[step] || 0;
                  });
                }
                contract.steps.map(step => {
                  objContract[step] = objContract.users.reduce((acc, cur) => acc + cur[step], 0);
                });
                objContract.today = countToday;

                objContract.users.sort((a, b) => (a.totalWork > b.totalWork) ? -1 : 1);
                this.contractProduction.push(objContract);
              });
            }

            this.contractProduction.sort((a, b) => (a.totalWork > b.totalWork) ? -1 : 1);
            if (this.contractProduction.length > 0) {
              this.dataProduction = {
                users: this.users,
                userGroups: this.userGroups,
                regulations: this.regulations,
                steps: this.stepsTranslated,
                contracts: this.contracts,
                contractsProduction: this.contractProduction
              };
              this.productionReportService.emitDataProduction(this.dataProduction);
            }
          });
        });
    });
  }

  getSessionsSize(sessions, stepList, regulation = null) {
    const allRegulations = sessions.map((session) => {
      const { contractId, startsAt, createdAt, id, modifiedAt, userId, step, status, ...regulations } = session;
      const getValidRegulations = (reg) => reg.split('#')[0];
      let listRegulations;
      if (regulation) {
        let regulationsSource = Object.keys(regulations).filter(reg => Number(reg) === regulation);
        if (stepList.startsWith('verify')) {
          regulationsSource = Object.keys(regulations).filter(reg => Number(reg.split('#')[1]) === regulation);
        }
        listRegulations = regulationsSource.filter(getValidRegulations);
      } else {
        listRegulations = Object.keys(regulations).filter(getValidRegulations);
      }

      let total = 0;
      listRegulations.forEach(item => total += regulations[item]);

      return total;
    });

    return allRegulations.reduce((acc, curr) => acc + curr, 0);
  }


  getTimeWorked(acc, curr) {
    const startTime = moment(curr.startsAt);
    const endTime = moment(curr.modifiedAt);
    return acc + endTime.diff(startTime);
  }

  setResources(value) {
    this.stepsTranslated = value;
  }

}
